import { render, staticRenderFns } from "./cp_jl_gl_syjl.vue?vue&type=template&id=1c6b88a8&scoped=true"
import script from "./cp_jl_gl_syjl.vue?vue&type=script&lang=js"
export * from "./cp_jl_gl_syjl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b88a8",
  null
  
)

export default component.exports